"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Ajv = require("ajv");

var ajv = new Ajv({
  jsonPointers: true,
  verbose: true
});

var apiSchema = require('./generated-schema.json');

ajv.addSchema(apiSchema, 'api.json');
exports.validateRequest = ajv.compile({
  $ref: 'api.json#/definitions/Request'
});
exports.validateResponse = ajv.compile({
  $ref: 'api.json#/definitions/Response'
});

function prettyPrintError(e) {
  switch (e.keyword) {
    case 'additionalProperties':
      {
        var unexpected = e.params.additionalProperty;
        return "Unexpected property '".concat(unexpected, "' found at root").concat(e.dataPath, " ");
      }

    case 'required':
      {
        var missing = e.params.missingProperty;
        return "Missing required property '".concat(missing, "' at root").concat(e.dataPath);
      }

    case 'type':
    case 'pattern':
      {
        return "Property at root".concat(e.dataPath, " ").concat(e.message);
      }
  }

  return JSON.stringify(e);
}

function parseRequest(jsonBlob) {
  var _a;

  var valid = exports.validateRequest(jsonBlob);

  if (!valid) {
    throw new Error("Validation Error: ".concat((_a = exports.validateRequest.errors) === null || _a === void 0 ? void 0 : _a.map(function (e) {
      return prettyPrintError(e);
    }).join(";\n")));
  }

  return jsonBlob;
}

exports.parseRequest = parseRequest;

function parseResponse(jsonBlob) {
  var _a;

  var valid = exports.validateResponse(jsonBlob);

  if (!valid) {
    throw new Error("\n      Validation Error:\n        input: ".concat(JSON.stringify(jsonBlob), ";\n\n        ").concat((_a = exports.validateResponse.errors) === null || _a === void 0 ? void 0 : _a.map(function (e) {
      return prettyPrintError(e);
    }).join(";\n"), "\n      "));
  }

  return jsonBlob;
}

exports.parseResponse = parseResponse;